import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  DEFAULT_GOOGLE_MAP_OPTIONS,
  DEFAULT_GOOGLE_STATIC_MAP_CONFIG,
  GoogleStaticMapConfig,
  type MapMarkerType,
  type RmaMapMarker,
} from '@rma/generic/maps/domain';
import { StaticGoogleMapComponent } from '@rma/public/maps/public/orc-static-google-map';

@Component({
  selector: 'rma-static-google-map-with-description',
  imports: [RouterModule, StaticGoogleMapComponent],
  templateUrl: './static-google-map-with-description.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StaticGoogleMapWithDescriptionComponent {
  @Input()
  config: GoogleStaticMapConfig | null = DEFAULT_GOOGLE_STATIC_MAP_CONFIG;

  @Input()
  options: google.maps.MapOptions = {
    ...DEFAULT_GOOGLE_MAP_OPTIONS,
    styles: undefined,
  };

  @Input()
  markers: RmaMapMarker[] | null = [];

  @Input()
  staticMapUrl: string | undefined;

  @Input()
  mapClickUrl!: string;

  @Input()
  mapType: MapMarkerType = 'Review';
}
